import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["slide", "dot", "prevBtn", "nextBtn", "prevPlaceholder", "bookDemo"]
  static values = { upgradeLabel: { type: String, default: "Upgrade to Pro" } }

  connect() {
    this.currentIndex = 0
    this.totalSlides = this.slideTargets.length
    this.updateView()
  }

  next() {
    if (this.currentIndex < this.totalSlides - 1) {
      this.currentIndex++
      this.updateView()
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.updateView()
    }
  }

  upgrade() {
    const learnMoreEl = this.element.closest('.modal')
    const learnMoreModal = Modal.getInstance(learnMoreEl)
    if (learnMoreModal) learnMoreModal.hide()

    const upgradeEl = document.getElementById('modal_upgrade_account')
    if (upgradeEl) {
      const upgradeModal = new Modal(upgradeEl)
      upgradeModal.show()
    }
  }

  updateView() {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("d-none", i !== this.currentIndex)
    })

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("learn-more-nav__dot--active", i === this.currentIndex)
    })

    const isFirst = this.currentIndex === 0
    const isLast = this.currentIndex === this.totalSlides - 1

    if (this.hasPrevBtnTarget) this.prevBtnTarget.classList.toggle("d-none", isFirst)
    if (this.hasPrevPlaceholderTarget) this.prevPlaceholderTarget.classList.toggle("d-none", !isFirst)

    if (this.hasBookDemoTarget) {
      this.bookDemoTarget.classList.toggle("d-none", !isLast)
    }

    if (isLast) {
      this.nextBtnTarget.innerHTML = `${this.upgradeLabelValue} <i class="fa-regular fa-arrow-right" style="font-size: 14px;"></i>`
      this.nextBtnTarget.setAttribute("data-action", "click->learn-more-slides#upgrade")
    } else {
      this.nextBtnTarget.innerHTML = 'Next <i class="fa-regular fa-arrow-right" style="font-size: 14px;"></i>'
      this.nextBtnTarget.setAttribute("data-action", "click->learn-more-slides#next")
    }
  }
}
